/* eslint-disable import/no-unresolved */
import { Box, Button, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { validationSchema } from '@/utils/helpers';
import Input from '@/components/Forms/Input';
import { useFetchPosProfileDetails } from '@/services/hooks';
import { setAlert } from '@/store/slices/alert';

interface PasscodeFormProps {
  handleFormAction: () => void;
}
const PasscodeForm: React.FC<PasscodeFormProps> = ({ handleFormAction }) => {
  const initialState = { passcode: 0 };
  const { passcode } = validationSchema;
  const dispatch = useDispatch();
  const { data: profile } = useFetchPosProfileDetails();

  const handleSubmit = async (values: typeof initialState) => {
    if (values.passcode === profile?.pass_code) {
      handleFormAction();
    } else {
      dispatch(setAlert({ type: 'error', message: 'Wrong passcode' }));
    }
  };

  return (
    <Box mt={2}>
      <Formik
        initialValues={initialState}
        onSubmit={handleSubmit}
        validationSchema={yup.object({
          passcode,
        })}
      >
        <Form>
          <Grid container spacing={4} justifyContent="flex-end">
            <Input type="password" label="" name="passcode" size={12} />

            <Grid item xs={6}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                sx={{ borderRadius: 1, marginLeft: 'auto' }}
              >
                Proceed
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default PasscodeForm;
